import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "438115f5-dee6-4694-ae7b-7708aed10de7",
  publicId: "14",
  name: "Impact sound in buildings",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
